<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar><div style="width:100%;padding-left: 2.667vw;padding-right: 2.667vw"><div style="font-size: 12px;line-height: 24px;width: 100%;margin: 10px 0;">*{{$t("setting.username")}}</div><div class="item" style="width:100%;">
            <div class="amount-wrapper" style="width:100%">
              <van-field
                v-model="username"
				:value="this.username"
                :placeholder="$t('setting.username_place')"
              />
              
            </div>
          </div><div style="font-size: 12px;line-height: 24px;width: 100%;margin: 10px 0;">*{{$t("setting.band_name")}}</div><div class="item" style="width:100%;">
            <div class="amount-wrapper" style="width:100%">
              <van-field
                v-model="bank"
                :placeholder="$t('setting.band_name_tip')"
              />
              
            </div>
          </div><div style="font-size: 12px;line-height: 24px;width: 100%;margin: 10px 0;">*{{$t("setting.branch_name")}}</div><div class="item" style="width:100%;">
            <div class="amount-wrapper" style="width:100%">
              <van-field
                v-model="bankfenhang"
                :placeholder="$t('setting.branch_name_tip')"
              />
              
            </div>
          </div><div style="font-size: 12px;line-height: 24px;width: 100%;margin: 10px 0;">*{{$t("setting.branch_code")}}</div><div class="item" style="width:100%;">
            <div class="amount-wrapper" style="width:100%">
              <van-field
                v-model="fhnumber"
                :placeholder="$t('setting.branch_code_tip')"
              />
              
            </div>
          </div><div style="font-size: 12px;line-height: 24px;width: 100%;margin: 10px 0;">*{{$t("setting.band_account")}}</div><div class="item" style="width:100%;">
            <div class="amount-wrapper" style="width:100%">
              <van-field
                v-model="bankid"
                :placeholder="$t('setting.band_account_tip')"
              />
              
            </div>
          </div><p style="padding: 0 20px;font-size: 12px;color: #ee0a24;">{{$t("setting.bank_warn")}}</p><div @click="bindCard()" style="height:40px;width:100%;background: linear-gradient(180deg, #fc78af, #f22678);color:#fff;font-size: 16px;text-align: center;border-radius: 10px;line-height: 40px;margin-top: 10px;">{{$t("setting.bank_ok")}}</div>
</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank:false,
      userInfo:{},
      bankid:"",
      username:"",
      mobile:"",
      bank:"",
      bank_code: "",
      bankfenhang: '',
      fhnumber:""
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCard(){
     
      if(this.userInfo.bankid){
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }
      if(this.bank === "" || this.bank === null || this.bank === undefined){
        this.$toast.fail(this.$t("setting.band_name_tip"));
        return false;
      }

      if(this.userInfo.bankid){
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }

      if(this.username===""){
        this.$toast(this.$t("setting.username_place"));
        return false;
      }
      if(this.bankfenhang===""){
        this.$toast(this.$t("setting.branch_name_tip"));
        return false;
      }
      if(this.fhnumber===""){
        this.$toast(this.$t("setting.branch_code_tip"));
        return false;
      }

     
    
      this.$http({
        method: 'post',
        data:{
          bankid:this.bankid,
          bank:this.bank,
          // bank_code: this.bank_code,
          username: this.username,
          bankfenhang: this.bankfenhang,
          fhnumber:this.fhnumber
         
        },
        url: 'user_set_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$router.push({path:'/Mine'})
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    showSelectBanks(){
      this.showBank = true;
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getBankList(){
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res=>{
        if(res.code === 200){
          this.banks = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    onConfirm(value) {
      this.bank = value.text
      this.bank_code = value.value
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){console.log(res.data.info.bankid);this.bankid=res.data.info.bankid;this.bank=res.data.info.bankinfo;this.bankfenhang=res.data.info.bankfenhang;this.fhnumber=res.data.info.fhnumber;this.username=res.data.info.username;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 30px;
  line-height: 50px;
}.nav-bar{background: linear-gradient(180deg, #fc78af, #f22678);}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.bankbox{
  padding: 15px;
  color: #000;
  background-color: #fff;
}
.bankbox .title{
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}
.main-box{
  background: #fff;

}
.main-box .label{
  padding: 20px;
  font-size: 35px;
  color: #797878;
}
::v-deep .van-picker__toolbar {
  height: 50px;
}
::v-deep .van-picker__cancel, .van-picker__confirm {
  padding: 0 20px;
  font-size: 20px;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.main-box p{
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
